import { Component, OnInit, Input, ViewChild, Output, EventEmitter, IterableDiffers } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { InterfaceElement} from '../../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { RowItem,HeaderItem } from '../../model/asd/asd-properties/asd-ie-type/asd-list';
import { InterfaceElementDataTypes } from '../../model/interfaceElement/interfaceElement-properties/interfaceElement-datatype';
import { InterfaceElementCustomization } from '../../model/asd/asd-properties/asd-ie/asd-interfaceElementCustomization';

@Component({
  selector: 'app-html-chart',
  templateUrl: './html-chart.component.html',
  styleUrls: ['./html-chart.component.css']
})
export class HtmlChartComponent implements OnInit {
  constructor(
    private iterableDiffers: IterableDiffers
  ) {
    this.iterableDiffer = this.iterableDiffers.find([]).create(null);
  }

  @Input() ieListType: InterfaceElement = new InterfaceElement();
  @Output() notifyListUpdate: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild(BaseChartDirective) public chart: BaseChartDirective;

  public iterableDiffer;

  /*chart types*/
  public barType: string = 'bar';
  public barHorizontalType: string = 'horizontalBar';
  public lineType: string = 'line';
  public pieType: string = 'pie';
  public chartCols: string = 'col-md-6';
  
  public chartDataSet: any[] = [];
  public chartData: any[] = [];
  public chartLabelSet: any[] = [];
  public chartLabel: string;
  public chartType: string = '';
  public chartDataSetToolTipList: any[] = [];
  public chartLegend: boolean = true;
  public chartId: boolean = true;
  public chartDisplayData  : any [] = [];
  public chartDisplayLabel : any [] = [];
  public chartToolTipDataList : {label: string, value: any[]} [] = [];

  public selected: string = 'horizontalBar';
  public isStruck: boolean = false;
  public isSetToDefault: boolean = false;

  public filteredChartData: { dataset: any[]; label: any[] } = { dataset: [], label: [] };
  public customizedLegends: { legend: any; tooltip: string; allowToSort: boolean; displayName: string }[] = [];

  public previousRowItemsLength: number;
  public recentRowItemsLength: number;

  public chartTypes: any[] = [{ key: 'line', value: 'line' }, { key: 'horizontalBar', value: 'horizontalBar' }];


  private chartBarColors = [
    {
      backgroundColor: 'rgba(103, 0, 3, 1)'
    }
  ];

  private chartPieColors: any[] = [{ backgroundColor: ['#66B962', '#620007', '#DCDCDC'] }];

  /*Pie demo based Variables*/
  public totalwords: number = 0;
  public totalabs: number = 0;
  public relpos: number = 0;
  public relneg: number = 0;
  public totalpos: number = 0;
  public totalneg: number = 0;
  /**/

  private getLegendCallback = (function(self) {
    function handle(chart) {
      return chart.legend.legendItems;
    }
    return function(chart) {
      return handle(chart);
    };
  })(this);

  public chartOption: any = {
    tooltips: {
      callbacks: {
        label: function(tooltipItem) {
          let labelToolTip = [];
          for (let l of this.chartDataSetToolTipList) {
            if (l.label == tooltipItem.yLabel) {
              for (let t of l.value) {
                labelToolTip.push(t);
              }
            }
          }
          return labelToolTip;
        }.bind(this),
        title: function(title) {
          let label = title[0].xLabel;
          return label;
        }
      }
    },
    animation: {
      duration: 0
    },
    legendCallback: this.getLegendCallback,
    legend: {
      position: 'top',
      onClick: function(e, legendItem) {
        var index = legendItem.datasetIndex;
        var ci = this.chart.chart;
        var meta = ci.getDatasetMeta(index);
        meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
        ci.update();
      }.bind(this)
    },
    scales: {
      xAxes: [{ ticks: { min: 0 } }]
    },
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true
    // scaleValuePaddingX: 5,
    // scaleValuePaddingY: 10
  };

  setLegendStyle(styleColor) {
    let styles = {
      'background-color': styleColor
    };
    return styles;
  }

  generatePieChartData(table:InterfaceElement){

    let pieChartLabels:string[] = [];
    let pieChartData:number[] = [];
    let headerItems = table.EntityList.HeaderItems;

    if(table.EntityList.RowItems.length > 0){
      for(let pd of table.EntityList.RowItems[0].ColItems ){
        let dataIndex = headerItems.map(function(d) { return d['Name']; }).indexOf(pd.Name);
        pieChartLabels.push(headerItems[dataIndex].DisplayName);
        pieChartData.push(pd.Value);
      }
    }
    this.chartDisplayLabel = pieChartLabels;
    this.chartDisplayData = pieChartData;
  }


  generateChartData(customTableType: InterfaceElementCustomization, headerItems: HeaderItem[], rowItems: RowItem[]){

/*    console.log('Headers: ', headerItems);
    console.log('RowItems: ',rowItems);
    
     let h1: HeaderItem = new HeaderItem;
     let h2: HeaderItem = new HeaderItem;
     let h3: HeaderItem = new HeaderItem;
     let h4: HeaderItem = new HeaderItem;
 
     h1.DisplayName = 'Sig';
     h1.Name = 'Sig';
     h1.AllowSorting = true;
     h1.Attributes = new Attribute;
     h1.Attributes.Visible = true;
     h1.CosyDataTypeDID = "System.Guid";
     h1.ToolTipText = 'Sig';
 
     h2.DisplayName = 'Direct';
     h2.Name = 'Direct';
     h2.AllowSorting = true;
     h2.Attributes = new Attribute;
     h2.Attributes.Visible = true;
     h2.CosyDataTypeDID = "System.Guid";
     h2.ToolTipText = 'Direct';
 
     h3.DisplayName = 'Diversity';
     h3.Name = 'Diversity';
     h3.AllowSorting = true;
     h3.Attributes = new Attribute;
     h3.Attributes.Visible = true;
     h3.CosyDataTypeDID = "System.Guid";
     h3.ToolTipText = 'Diversity';
 
     h4.DisplayName = 'TSCCS';
     h4.Name = 'TSCCS';
     h4.AllowSorting = true;
     h4.Attributes = new Attribute;
     h4.Attributes.Visible = true;
     h4.CosyDataTypeDID = "System.Guid";
     h4.ToolTipText = 'TSCCS';
 
     headerItems = [];
     headerItems.push(h1);
     headerItems.push(h2);
     headerItems.push(h3);
     headerItems.push(h4);
 
     let r1: RowItem = new RowItem;
     let c1 : ColItem = new ColItem;
     let c2 : ColItem = new ColItem;
     let c3 : ColItem = new ColItem;
     let c4 : ColItem = new ColItem;
 
     c1.Name = 'Sig';
     c1.Value = 1.0;
 
     c2.Name = 'Direct';
     c2.Value = 2.0;
 
     c3.Name = 'Diversity';
     c3.Value = 3.0;
 
     c4.Name = 'TSCCS';
     c4.Value = 4.0;
 
     let cols:ColItem [] = [];
 
     r1.ColItems = cols;
 
     r1.ColItems.push(c1);
     r1.ColItems.push(c2);
     r1.ColItems.push(c3);
     r1.ColItems.push(c4);
 
     rowItems = [];
     rowItems.push(r1);*/
 
    
     let headerIndex = headerItems.map(function(d) { return d['Name']; }).indexOf(customTableType.Properties.ChartLabelCol);
     let chartData : any[] = [];
     let tooltipList : {label: string, value : any[]}[] = [];
     let toolTipIndexList : any[] =[];
    
     for(let dc of customTableType.Properties.ChartDataCols){
       let dataIndex = headerItems.map(function(d) { return d['Name']; }).indexOf(dc);
       let chartdataItem : {data: any[], label: string, index: number} = {data:[], label:'', index: -1} ;
       chartData.push({ 'name' : dc, 'index': dataIndex});
       if(dataIndex > -1){
         chartdataItem.label = dc;
         chartdataItem.data = [];
         chartdataItem.index = dataIndex;
         this.chartDisplayData.push(chartdataItem);
       }
     }
 
     for(let tc of customTableType.Properties.ChartTooltipCols){
      let tooltipIndex = headerItems.map(function(d) { return d['Name']; }).indexOf(tc);
      toolTipIndexList.push(tooltipIndex);
     }
 
     for(let r of rowItems){
      this.chartDisplayLabel.push(r.ColItems[headerIndex].Value);
      let tdi = {label :r.ColItems[headerIndex].Value , value : []};
         for(let t of toolTipIndexList){
           if(t > -1 && r.ColItems[t] != null){
             let tooltipValue : string = r.ColItems[t].Name+':'+ r.ColItems[t].Value;
             tdi.value.push(tooltipValue);
           }
         }
      for(let d of this.chartDisplayData){
         if(d.index > -1 && d.label == r.ColItems[d.index].Name){
             d.data.push(r.ColItems[d.index].Value);
         }
       }
       tooltipList.push(tdi);
     }
     this.chartToolTipDataList = tooltipList;
   }

   filterChartSet(filteredTable: InterfaceElement, dataSet: any[], 
    chartLabel: string, chartType: string){

    let chartLabelSet : any[]=[];
    let chartDisplayLimit : number = -1;
    let slicedRowItems : RowItem[] = [];

    if(filteredTable.CustomizeOptions.Properties != null && filteredTable.CustomizeOptions.Properties.ChartType == chartType){
      chartDisplayLimit = filteredTable.CustomizeOptions.Properties.ChartDisplayLimit;
    }
    slicedRowItems = filteredTable.EntityList.RowItems.slice(0,chartDisplayLimit);

    for(let d of dataSet){
      d.data = [];
    }
    for(let r of slicedRowItems){
      for(let c of r.ColItems){
        for(let d of dataSet){
          if(d.label == c.Name){
            d.data.push(c.Value);
          }
        }
        if(c.Name == chartLabel){
            chartLabelSet.push(c.Value);
        }
      }
    }
    return {'dataset': dataSet, 'label': chartLabelSet};
  }

  sortBy(legendItem: any, order: string) {
    let name: string;
    let dataTypeID: string = '';
    let rIndex: number = -1;
    name = legendItem.text;

    for (let h of this.ieListType.EntityList.HeaderItems) {
      if (h.Name == name) {
        dataTypeID = h.CosyDataTypeDID;
      }
    }

    if (this.ieListType.EntityList.RowItems != null && this.ieListType.EntityList.RowItems.length > 0) {
      rIndex = this.ieListType.EntityList.RowItems[0].ColItems.map(function(d) {
        return d['Name'];
      }).indexOf(name);
      if (rIndex > -1) {
        if (dataTypeID.toLowerCase == InterfaceElementDataTypes.IntegerDT.toLowerCase) {
          order == 'desc'
          ? this.ieListType.EntityList.RowItems.sort((n1, n2) => n2.ColItems[rIndex].Value - n1.ColItems[rIndex].Value)
          : this.ieListType.EntityList.RowItems.sort((n1, n2) => n1.ColItems[rIndex].Value - n2.ColItems[rIndex].Value);
           
        } else if (dataTypeID.toLowerCase == InterfaceElementDataTypes.StringDT.toLowerCase) {
          order == 'desc'
          ? this.ieListType.EntityList.RowItems.sort((a, b) => 0 - (a.ColItems[rIndex].Value > b.ColItems[rIndex].Value ? 1 : -1))
          : this.ieListType.EntityList.RowItems.sort((a, b) => 0 - (b.ColItems[rIndex].Value > a.ColItems[rIndex].Value ? 1 : -1));
          
        }
      }
      this.setFilteredResults(this.ieListType);
    }
  }

  resetHiddenLegendItems() {
    let legendItems: any[] = [];
    let hiddenLegendItems: any[] = [];

    if (this.chart != null) {
      legendItems = null //this.chart.chart.legend.legendItems; neue Version TODO

      for (let legendItem of legendItems) {
        if (legendItem.hidden) {
          hiddenLegendItems.push(legendItem);
        }
      }

      for (let hl of hiddenLegendItems) {
        this.processLegendTerm(hl);
      }
    }
  }


  

  setFilteredResults(ie: InterfaceElement) {
    this.filteredChartData = this.filterChartSet(ie, this.chartDataSet, this.chartLabel, this.chartType);
    this.chartDataSet = this.filteredChartData.dataset;
    this.chartLabelSet = this.filteredChartData.label;
    this.resetHiddenLegendItems();
  }

  processLegendTerm(legendItem) {
    let index = legendItem.datasetIndex;
    let ci = this.chart.chart;
    let meta = ci.getDatasetMeta(index);

    meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
    ci.update();
    let legendElement = document.getElementById(legendItem.text);

    this.isStruck = legendElement.style.getPropertyValue('text-decoration') == 'line-through';
    if (this.isStruck) {
      legendElement.style.setProperty('text-decoration', '');
    } else {
      legendElement.style.setProperty('text-decoration', 'line-through');
    }
  }

  setToDefault() {
    this.setFilteredResults(this.ieListType);
    this.isSetToDefault = true;
    this.notifyListUpdate.emit(this.ieListType);
    this.isSetToDefault = false;
  }

  createCustomizedLegends(legends) {
    for (let header of this.ieListType.EntityList.HeaderItems) {
      for (let legend of legends) {
        if (legend.text == header.Name) {
          this.customizedLegends.push({ legend: legend, tooltip: header.ToolTipText, allowToSort: header.AllowSorting, displayName: header.DisplayName });
        }
      }
    }
    return this.customizedLegends;
  }

  initChartAttributes(value) {
    this.selected = value;
    if (this.ieListType.CustomizeOptions.Properties.ChartType == 'horizontalBar') {
      if (typeof this.chart == 'undefined') {
        this.filteredChartData.dataset = this.chartDisplayData;
        this.filteredChartData.label = this.chartDisplayLabel;
        this.chartType = this.ieListType.CustomizeOptions.Properties.ChartType;
        this.chartId = this.ieListType.CustomizeOptions.Properties.id;
        this.chartDataSetToolTipList = this.chartToolTipDataList;
        this.chartLabel = this.ieListType.CustomizeOptions.Properties.ChartLabelCol;
      }
      else {
        this.chartType = this.ieListType.CustomizeOptions.Properties.ChartType;
        this.filteredChartData = this.filterChartSet(this.ieListType, this.chartDataSet, this.chartLabel, this.chartType);
      }
      this.chartDataSet = this.filteredChartData.dataset;
      this.chartLabelSet = this.filteredChartData.label;
    }
    else if (this.ieListType.CustomizeOptions.Properties.ChartType == 'pie') {
      this.chartType = this.ieListType.CustomizeOptions.Properties.ChartType;
      this.chartDataSet = this.chartDisplayData;
      this.chartLabelSet = this.chartDisplayLabel;
    }
 
  }

  ngOnInit() {
    
    this.initChartAttributes(this.selected);
    let defaultHeaderItems = JSON.parse(JSON.stringify(this.ieListType.EntityList.HeaderItems));
    let defaultRowItems = this.ieListType.EntityList.RowItems;
    if(this.ieListType.CustomizeOptions.Properties.ChartType == this.barHorizontalType){
      this.generateChartData(this.ieListType.CustomizeOptions, defaultHeaderItems, defaultRowItems);
    }
    else if(this.ieListType.CustomizeOptions.Properties.ChartType == this.pieType){
      this.generatePieChartData(this.ieListType);
    }

  }

  ngDoCheck() {
   
      if (this.ieListType != null && this.chartType == this.barHorizontalType) {
      let changes = this.iterableDiffer.diff(this.ieListType.EntityList.RowItems);
      if (changes && !this.isSetToDefault && this.ieListType.CustomizeOptions != null) {
        this.filteredChartData = this.filterChartSet(this.ieListType, this.chartDataSet, this.chartLabel, this.chartType);
        this.chartDataSet = this.filteredChartData.dataset;
        this.chartLabelSet = this.filteredChartData.label;
        this.resetHiddenLegendItems();
      }
    }
  }

  ngAfterViewInit() {
    setTimeout(_ => {
      if (this.chart != null) {
        this.customizedLegends = this.createCustomizedLegends(this.chart.chart.generateLegend());
        this.initChartAttributes(this.selected);
      }
    });
  }

  
}
